<template>
    <b-container>
        <h3 class="my-4 text-center">Editar Producto</h3>

        <b-row align-h="center">
            <b-col cols="6">
                <form @submit.prevent="editarProducto(producto)">
                    <b-row class="my-1">
                        <b-col sm="3">
                            <label for="input-default">Nombre:</label>
                        </b-col>
                        <b-col sm="9">
                            <b-form-input type="text" size="sm" v-model="$v.producto.NOM_PRODUCTO.$model"></b-form-input>
                        </b-col>
                        <b-col sm="9" offset-sm="3">
                            <p class="text-danger text-validacion" v-if="!$v.producto.NOM_PRODUCTO.minLength">
                                El nombre debe tener mínimo 4 carácteres
                            </p>
                        </b-col>
                    </b-row>
                    <b-row class="my-1">
                        <b-col sm="3">
                            <label for="input-default">Precio:</label>
                        </b-col>
                        <b-col sm="9">
                            <b-form-input type="number" size="sm" step="any" v-model="$v.producto.IMP_UNITARIO.$model"></b-form-input>
                        </b-col>
                    </b-row>
                    <div>
                        <b-form-checkbox v-model="producto.IND_ACTIVO" name="check-button" switch>
                            Disponible para vender
                        </b-form-checkbox>
                    </div>
                    <button type="submit" class="btn btn-warning btn-sm mt-3" :disabled="$v.$invalid || carga">Editar</button>
                </form>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { required, minLength } from 'vuelidate/lib/validators'

export default {
    name: 'Editar',
    data() {
        return {
            id: this.$route.params.id
        }
    },
    methods: {
        ...mapActions(['encontrarProducto', 'editarProducto'])
    },
    created() {
        this.encontrarProducto(this.id);
    },
    computed: {
        ...mapState(['producto']),
        ...mapState(['carga'])
    },
    validations: {
        producto: {
            NOM_PRODUCTO: { required, minLength: minLength(4) },
            IMP_UNITARIO: { required }
        }
    }
}
</script>